import { Temporal } from 'temporal-polyfill';
import { z } from 'zod';

export const plainSessionLikeSchema = z.object({
  id: z.string(),
  startInstant: z.instanceof(Temporal.Instant),
  endInstant: z.instanceof(Temporal.Instant),
  studentGroupId: z.string().optional(),
  sessionsLeft: z.number().optional(),
});

export type PlainSessionLike = z.infer<typeof plainSessionLikeSchema>;
